<template>
	<div class="my-tinymce">
		<div class="editor-tips" v-if="showTips">
			<div class="tip-item">
				<span class="tip-icon">💡</span>
				<span class="tip-text">提示：微信公众号图片由于防盗链机制无法直接粘贴，请保存图片后手动上传</span>
			</div>
		</div>
		<Editor v-model="contentValue" :init="myInit" :disabled="disabled" />
	</div>
</template>

<script>
	import {
		url,
		mediaUrl
	} from '@/api/url'
	import {
		ElLoading
	} from 'element-plus'
	import {
		onMounted,
		onUnmounted,
		reactive,
		toRefs,
		watch,
		nextTick
	} from 'vue'
	import axios from 'axios'
	// 引入tinymce编辑器
	import Editor from '@tinymce/tinymce-vue'
	import tinymce from 'tinymce/tinymce' // tinymce默认hidden，不引入则不显示编辑器
	// 导入配置文件
	import './teditorjs/importTinymce'
	import {
		init
	} from './teditorjs/config'
	import {
		setStorage,
		getStorage,
		getToken
	} from '@/utils/util'
	let token = getToken()

	export default {
		name: 'tEditor',
		components: {
			Editor
		},
		props: {
			// 绑定文本值
			modelValue: {
				type: String,
				default: ''
			},
			// placeholder
			placeholder: {
				type: String,
				default: '请输入内容'
			},
			disabled: {
				type: Boolean,
				default: false
			},
			// 默认样式
			style: {
				type: Object,
				default: () => {
					return {
						width: '100%',
						heigth: '500'  // 增加默认高度从300到500
					}
				}
			},
			// 图片上传服务器地址
			imgUploadUrl: {
				type: String,
				default: ''
			},
			// 是否显示提示
			showTips: {
				type: Boolean,
				default: true
			}
		},
		setup(props, {
			emit
		}) {
			const state = reactive({
				myInit: customer(init), // 初始化
				contentValue: props.modelValue, // 绑定文本
				timeout: null,
			})
			token = getToken()

			// 微信占位符计数器
			let placeholderCounter = 0

			onMounted(() => {
				nextTick(() => {
					tinymce.init({})
				})
				window.addEventListener("focusin", onFocusIn, true);
			})
			onUnmounted(() => {
				// tinymce.remove()
				window.removeEventListener("focusin", onFocusIn);
			})


			// 侦听文本变化并传给外界
			watch(() => state.contentValue, (n) => {
				debounce(() => {
					emit('update:modelValue', state.contentValue)
				})
			})
			// 侦听默认值 外界第一次传进来一个 v-model 就赋值给 contentValue
			watch(() => props.modelValue, (n) => {
				if (n && n !== state.contentValue) {
					state.contentValue = n
				}
			})

			function onFocusIn(e) {
				e.stopImmediatePropagation() //阻止当前和后面的一系列事件
			}

			function debounce(fn, wait = 400) {
				// console.log('进到了防抖', wait)
				if (state.timeout !== null) {
					clearTimeout(state.timeout)
				}
				state.timeout = setTimeout(fn, wait)
			}

			// 参数自定义初始化
			function customer(init) {
				// 允许外界传进来高度和placeholder
				init.height = props.style.heigth
				init.placeholder = props.placeholder

				// 粘贴图片 自动处理 base64
				init.urlconverter_callback = (url, node, onSave, name) => {
					// console.log(tinymce.activeEditor)
					if (node === 'img' && url.startsWith('blob:')) {
						tinymce.activeEditor && tinymce.activeEditor.uploadImages()
					}
					return url
				}

				// 粘贴事件处理，特别处理微信图片
				init.paste_postprocess = (plugin, args) => {
					console.log('粘贴后处理开始')

					// 延迟处理，让TinyMCE先完成内容处理和同步
					setTimeout(() => {
						console.log('开始延迟处理微信图片')

						// 在编辑器内容中查找微信图片
						if (tinymce.activeEditor) {
							const editorBody = tinymce.activeEditor.getBody()
							const images = editorBody.querySelectorAll('img')

							console.log('在编辑器中找到图片数量:', images.length)

							images.forEach((img, index) => {
								const src = img.src || img.getAttribute('data-src')
								console.log(`检查图片 ${index + 1}:`, src)

								// 检查是否是微信图片
								if (src && (src.includes('mmbiz.qpic.cn') || src.includes('wx.qlogo.cn') ||
									src.includes('weixin') || src.includes('qpic') || src.includes('mmecoa.qpic.cn'))) {
									console.log(`发现微信图片 ${index + 1}:`, src)
									handleWechatImage(img, src)
								} else if (src && src.startsWith('http') && !src.includes(mediaUrl)) {
									// 其他外部图片
									console.log(`发现外部图片 ${index + 1}:`, src)
									convertExternalImageToLocal(img, src)
								}
							})
						}
					}, 1000) // 增加延迟时间到1秒，确保TinyMCE完成所有处理
				}

				// 图片上传
				init.images_upload_handler = (blobInfo, success, failure) => {
					imgUploadFn(blobInfo, success, failure)
				}
				//视频上传
				init.file_picker_callback = (callback, valute, meta) => {
					viedoUploadFn(callback, valute, meta)
				}

				// 添加TinyMCE编辑器设置
				init.setup = (editor) => {
					// 添加首行缩进按钮 - 使用自定义SVG图标
					editor.ui.registry.addIcon('indent2em', '<svg width="24" height="24" viewBox="0 0 24 24"><path d="M3 3h18v2H3V3zm6 4h12v2H9V7zm-6 4h18v2H3v-2zm6 4h12v2H9v-2zm-6 4h18v2H3v-2z" fill="currentColor"/><path d="M3 7v10l4-5-4-5z" fill="currentColor"/></svg>')

					editor.ui.registry.addButton('indent2em', {
						icon: 'indent2em',
						tooltip: '首行缩进2字符',
						onAction: function() {
							// 获取当前选区
							const selection = editor.selection
							const range = selection.getRng()
							const selectedContent = selection.getContent()

							// 如果有选中内容，只对选中内容的第一行（第一个段落）应用首行缩进
							if (selectedContent && !selection.isCollapsed()) {
								console.log('处理多行选中，只对第一行应用首行缩进')

								// 获取选区的起始容器，找到第一个段落
								const startContainer = range.startContainer
								const firstParagraph = editor.dom.getParent(startContainer, 'p,div,h1,h2,h3,h4,h5,h6')

								if (firstParagraph) {
									console.log('找到第一个段落:', firstParagraph.tagName, firstParagraph.textContent.substring(0, 30))
									// 只对第一个段落应用首行缩进
									editor.dom.setStyle(firstParagraph, 'text-indent', '2em')
									console.log('已对第一个段落应用首行缩进')
								} else {
									console.log('未找到段落，创建新段落')
									// 如果没有找到段落，将选中内容包装在一个带首行缩进的段落中
									selection.setContent('<p style="text-indent: 2em;">' + selectedContent + '</p>')
								}

								// 保持选区
								selection.setRng(range)
							} else {
								// 单个段落或光标位置的处理
								const selectedNode = selection.getNode()
								const parentP = editor.dom.getParent(selectedNode, 'p,div,h1,h2,h3,h4,h5,h6')

								if (parentP) {
									// 直接给段落添加首行缩进样式
									console.log('单段落首行缩进:', parentP.tagName, parentP.textContent.substring(0, 20) + '...')
									editor.dom.setStyle(parentP, 'text-indent', '2em')
									console.log('段落样式已设置:', editor.dom.getStyle(parentP, 'text-indent'))
								} else {
									// 如果当前不在段落中，创建段落并添加首行缩进
									console.log('创建新段落并应用首行缩进')
									editor.execCommand('formatBlock', false, 'p')
									const newP = editor.dom.getParent(selection.getNode(), 'p')
									if (newP) {
										editor.dom.setStyle(newP, 'text-indent', '2em')
										console.log('新段落样式已设置:', editor.dom.getStyle(newP, 'text-indent'))
									}
								}
							}
						}
					})

					// 添加格式刷按钮 - 使用自定义SVG图标
					let formatPainterActive = false
					let copiedFormat = null

					// 专门的首行缩进应用函数
					const applyTextIndent = (element, indentValue) => {
						console.log('专用函数应用首行缩进:', indentValue, '到元素:', element.tagName)

						// 方法1: 清除现有的text-indent，然后重新设置
						element.style.removeProperty('text-indent')

						// 方法2: 使用TinyMCE的DOM API
						editor.dom.setStyle(element, 'text-indent', indentValue)

						// 方法3: 直接设置DOM样式
						element.style.textIndent = indentValue

						// 方法4: 强制更新style属性
						const currentStyle = element.getAttribute('style') || ''
						const cleanStyle = currentStyle.replace(/text-indent\s*:\s*[^;]+;?/gi, '').trim()
						const newStyle = cleanStyle + (cleanStyle ? '; ' : '') + `text-indent: ${indentValue}`
						element.setAttribute('style', newStyle)

						console.log('首行缩进应用完成，最终样式:', element.getAttribute('style'))
						return element.style.textIndent || editor.dom.getStyle(element, 'text-indent')
					}

					// 添加Word风格的格式刷图标
					editor.ui.registry.addIcon('formatpainter', '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8 3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V4H17C17.5523 4 18 4.44772 18 5V7C18 7.55228 17.5523 8 17 8H16V9L12 13L8 9V8H7C6.44772 8 6 7.55228 6 7V5C6 4.44772 6.44772 4 7 4H8V3Z" fill="currentColor"/><path d="M10 14L12 16L14 14V20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20V14Z" fill="currentColor"/><circle cx="12" cy="5.5" r="0.5" fill="white"/></svg>')

					// 添加激活状态的格式刷图标（高亮版本）
					editor.ui.registry.addIcon('formatpainter-active', '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8 3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V4H17C17.5523 4 18 4.44772 18 5V7C18 7.55228 17.5523 8 17 8H16V9L12 13L8 9V8H7C6.44772 8 6 7.55228 6 7V5C6 4.44772 6.44772 4 7 4H8V3Z" fill="#0078d4" stroke="#0078d4" stroke-width="1"/><path d="M10 14L12 16L14 14V20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20V14Z" fill="#0078d4"/><circle cx="12" cy="5.5" r="0.5" fill="white"/><path d="M6 6H18M6 6.5H18" stroke="#ffd700" stroke-width="0.5" opacity="0.8"/></svg>')

					editor.ui.registry.addToggleButton('formatpainter', {
						icon: 'formatpainter',
						tooltip: '格式刷：像Word一样使用 - 1.选中源格式文本 2.点击格式刷 3.选中目标文本',
						onSetup: function(api) {
							// 设置按钮的激活状态样式
							const updateButtonState = (isActive) => {
								const button = document.querySelector('[aria-label*="格式刷"]')
								if (button) {
									if (isActive) {
										button.style.backgroundColor = '#0078d4'
										button.style.color = 'white'
										button.style.border = '2px solid #106ebe'
										button.style.boxShadow = '0 0 0 1px #106ebe'
										// 更换为激活状态的图标
										const icon = button.querySelector('svg')
										if (icon) {
											icon.innerHTML = '<path d="M8 3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V4H17C17.5523 4 18 4.44772 18 5V7C18 7.55228 17.5523 8 17 8H16V9L12 13L8 9V8H7C6.44772 8 6 7.55228 6 7V5C6 4.44772 6.44772 4 7 4H8V3Z" fill="white" stroke="white" stroke-width="1"/><path d="M10 14L12 16L14 14V20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20V14Z" fill="white"/><circle cx="12" cy="5.5" r="0.5" fill="#0078d4"/><path d="M6 6H18M6 6.5H18" stroke="#ffd700" stroke-width="0.5" opacity="0.8"/>'
										}
									} else {
										button.style.backgroundColor = ''
										button.style.color = ''
										button.style.border = ''
										button.style.boxShadow = ''
										// 恢复普通状态的图标
										const icon = button.querySelector('svg')
										if (icon) {
											icon.innerHTML = '<path d="M8 3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V4H17C17.5523 4 18 4.44772 18 5V7C18 7.55228 17.5523 8 17 8H16V9L12 13L8 9V8H7C6.44772 8 6 7.55228 6 7V5C6 4.44772 6.44772 4 7 4H8V3Z" fill="currentColor"/><path d="M10 14L12 16L14 14V20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20V14Z" fill="currentColor"/><circle cx="12" cy="5.5" r="0.5" fill="white"/>'
										}
									}
								}
							}

							// 监听按钮状态变化
							api.onSetup = () => {
								setTimeout(() => updateButtonState(false), 100)
							}

							return {
								updateButtonState
							}
						},
						onAction: function(api) {
							const selection = editor.selection
							const selectedContent = selection.getContent()

							if (!formatPainterActive) {
								// 第一步：复制格式
								if (!selectedContent || selection.isCollapsed()) {
									// 如果没有选中文本，提示用户
									editor.notificationManager.open({
										text: '请先选中要复制格式的文本，然后点击格式刷',
										type: 'warning',
										timeout: 3000
									})
									return
								}

								// 获取选中文本的格式 - 改进格式获取逻辑，特别处理多行选择
								const selectedNode = selection.getNode()
								const range = selection.getRng()
								const selectedBlocks = selection.getSelectedBlocks()

								console.log('选中的节点:', selectedNode)
								console.log('选中的内容:', selectedContent)
								console.log('选中的块级元素:', selectedBlocks)
								console.log('是否多行选择:', selectedBlocks.length > 1)

								// 多行选择时，从第一个有效的段落元素获取格式
								let formatSourceElement = selectedNode
								let formatSourceBlock = null

								if (selectedBlocks.length > 1) {
									console.log('多行选择模式，寻找第一个有首行缩进的段落')
									// 寻找第一个有首行缩进的段落
									for (let block of selectedBlocks) {
										const tagName = block.tagName.toLowerCase()
										if (['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tagName)) {
											const blockStyle = window.getComputedStyle(block)
											const textIndent = blockStyle.textIndent || editor.dom.getStyle(block, 'text-indent')
											console.log(`检查${tagName}的首行缩进:`, textIndent)

											if (textIndent && textIndent !== '0px' && textIndent !== 'none') {
												console.log(`找到有首行缩进的段落:`, block.tagName, textIndent)
												formatSourceElement = block
												formatSourceBlock = block
												break
											}
										}
									}

									// 如果没找到有首行缩进的，使用第一个段落
									if (!formatSourceBlock) {
										for (let block of selectedBlocks) {
											const tagName = block.tagName.toLowerCase()
											if (['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tagName)) {
												formatSourceElement = block
												formatSourceBlock = block
												console.log('使用第一个段落作为格式源:', block.tagName)
												break
											}
										}
									}
								} else {
									// 单行选择，使用原来的逻辑
									const parentElement = editor.dom.getParent(selectedNode, 'p,div,h1,h2,h3,h4,h5,h6')
									formatSourceBlock = parentElement || selectedNode
								}

								console.log('最终格式源元素:', formatSourceElement)
								console.log('最终格式源块级元素:', formatSourceBlock)

								// 获取计算后的样式（更准确）
								const computedStyle = window.getComputedStyle(formatSourceElement)
								const blockComputedStyle = formatSourceBlock ? window.getComputedStyle(formatSourceBlock) : computedStyle

								// 检查是否在格式化元素内
								const boldElement = editor.dom.getParent(formatSourceElement, 'strong,b')
								const italicElement = editor.dom.getParent(formatSourceElement, 'em,i')
								const underlineElement = editor.dom.getParent(formatSourceElement, 'u')

								// 复制所有相关的格式属性 - 改进格式检测，区分内联和块级样式，支持多行
								copiedFormat = {
									// 字体相关（优先从格式源元素获取）
									fontFamily: computedStyle.fontFamily || editor.dom.getStyle(formatSourceElement, 'font-family') || blockComputedStyle.fontFamily,
									fontSize: computedStyle.fontSize || editor.dom.getStyle(formatSourceElement, 'font-size') || blockComputedStyle.fontSize,
									fontWeight: computedStyle.fontWeight || editor.dom.getStyle(formatSourceElement, 'font-weight') || blockComputedStyle.fontWeight,
									fontStyle: computedStyle.fontStyle || editor.dom.getStyle(formatSourceElement, 'font-style') || blockComputedStyle.fontStyle,

									// 颜色相关（优先从格式源元素获取）
									color: computedStyle.color || editor.dom.getStyle(formatSourceElement, 'color') || blockComputedStyle.color,
									backgroundColor: computedStyle.backgroundColor || editor.dom.getStyle(formatSourceElement, 'background-color') || blockComputedStyle.backgroundColor,

									// 文本装饰（优先从格式源元素获取）
									textDecoration: computedStyle.textDecoration || editor.dom.getStyle(formatSourceElement, 'text-decoration') || blockComputedStyle.textDecoration,

									// 段落格式（优先从块级格式源获取）
									textAlign: blockComputedStyle.textAlign || editor.dom.getStyle(formatSourceBlock, 'text-align'),
									lineHeight: blockComputedStyle.lineHeight || editor.dom.getStyle(formatSourceBlock, 'line-height'),
									textIndent: blockComputedStyle.textIndent || editor.dom.getStyle(formatSourceBlock, 'text-indent'),

									// 检查是否有粗体、斜体等格式 - 改进检测逻辑
									isBold: !!boldElement ||
											computedStyle.fontWeight === 'bold' ||
											computedStyle.fontWeight === '700' ||
											parseInt(computedStyle.fontWeight) >= 700 ||
											formatSourceElement.tagName === 'STRONG' ||
											formatSourceElement.tagName === 'B',
									isItalic: !!italicElement ||
											 computedStyle.fontStyle === 'italic' ||
											 formatSourceElement.tagName === 'EM' ||
											 formatSourceElement.tagName === 'I',
									isUnderline: !!underlineElement ||
												computedStyle.textDecoration.includes('underline') ||
												formatSourceElement.tagName === 'U'
								}

								// 额外的调试信息 - 更新为新的变量
								console.log('粗体检测:', {
									boldElement: !!boldElement,
									fontWeight: computedStyle.fontWeight,
									tagName: formatSourceElement.tagName,
									isBold: copiedFormat.isBold
								})
								console.log('段落格式检测:', {
									textIndent: copiedFormat.textIndent,
									textAlign: copiedFormat.textAlign,
									lineHeight: copiedFormat.lineHeight,
									formatSourceElement: formatSourceElement ? formatSourceElement.tagName : 'none',
									formatSourceBlock: formatSourceBlock ? formatSourceBlock.tagName : 'none',
									isMultiLine: selectedBlocks.length > 1
								})
								console.log('完整的复制格式:', copiedFormat)

								console.log('复制的格式:', copiedFormat)

								formatPainterActive = true
								api.setActive(true)

								// 更新按钮样式为激活状态
								setTimeout(() => {
									const button = document.querySelector('[aria-label*="格式刷"]')
									if (button) {
										button.style.backgroundColor = '#0078d4'
										button.style.color = 'white'
										button.style.border = '2px solid #106ebe'
										button.style.boxShadow = '0 0 0 1px #106ebe'
										button.style.transform = 'scale(1.05)'
										// 更换为激活状态的图标
										const icon = button.querySelector('svg')
										if (icon) {
											icon.innerHTML = '<path d="M8 3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V4H17C17.5523 4 18 4.44772 18 5V7C18 7.55228 17.5523 8 17 8H16V9L12 13L8 9V8H7C6.44772 8 6 7.55228 6 7V5C6 4.44772 6.44772 4 7 4H8V3Z" fill="white" stroke="white" stroke-width="1"/><path d="M10 14L12 16L14 14V20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20V14Z" fill="white"/><circle cx="12" cy="5.5" r="0.5" fill="#0078d4"/><path d="M6 6H18M6 6.5H18" stroke="#ffd700" stroke-width="0.5" opacity="0.8"/>'
										}
									}
								}, 100)

								// 显示提示
								editor.notificationManager.open({
									text: '格式已复制！现在选中要应用格式的文本，再次点击格式刷',
									type: 'success',
									timeout: 4000
								})
							} else {
								// 第二步：应用格式 - 改进应用逻辑
								if (!selectedContent || selection.isCollapsed()) {
									// 如果没有选中目标文本，提示用户
									editor.notificationManager.open({
										text: '请选中要应用格式的目标文本',
										type: 'warning',
										timeout: 3000
									})
									return
								}

								if (copiedFormat) {
									console.log('开始手动应用格式:', copiedFormat)

									// 保存当前选区
									const currentRange = selection.getRng()
									const targetNode = selection.getNode()
									const targetElement = editor.dom.getParent(targetNode, 'p,div,span,h1,h2,h3,h4,h5,h6')

									// 应用颜色格式（先应用颜色，因为这些命令需要选区）
									if (copiedFormat.color && copiedFormat.color !== '' && copiedFormat.color !== 'rgb(0, 0, 0)') {
										console.log('手动应用前景色:', copiedFormat.color)
										editor.execCommand('ForeColor', false, copiedFormat.color)
									}
									if (copiedFormat.backgroundColor && copiedFormat.backgroundColor !== '' && copiedFormat.backgroundColor !== 'rgba(0, 0, 0, 0)' && copiedFormat.backgroundColor !== 'transparent') {
										console.log('手动应用背景色:', copiedFormat.backgroundColor)
										editor.execCommand('HiliteColor', false, copiedFormat.backgroundColor)
									}

									// 应用文本格式（粗体、斜体、下划线）- 改进应用方式
									if (copiedFormat.isBold) {
										console.log('手动应用粗体格式，当前选区:', selection.getContent())
										// 检查当前是否已经是粗体，如果不是才应用
										const currentNode = selection.getNode()
										const currentWeight = window.getComputedStyle(currentNode).fontWeight
										console.log('当前字体粗细:', currentWeight)
										if (parseInt(currentWeight) < 700) {
											editor.execCommand('Bold')
										}
									}
									if (copiedFormat.isItalic) {
										console.log('手动应用斜体格式')
										const currentNode = selection.getNode()
										const currentStyle = window.getComputedStyle(currentNode).fontStyle
										if (currentStyle !== 'italic') {
											editor.execCommand('Italic')
										}
									}
									if (copiedFormat.isUnderline) {
										console.log('手动应用下划线格式')
										const currentNode = selection.getNode()
										const currentDecoration = window.getComputedStyle(currentNode).textDecoration
										if (!currentDecoration.includes('underline')) {
											editor.execCommand('Underline')
										}
									}

									// 应用字体相关样式 - 改进字体应用方式
									if (copiedFormat.fontFamily && copiedFormat.fontFamily !== '' && copiedFormat.fontFamily !== 'inherit') {
										console.log('手动应用字体:', copiedFormat.fontFamily)
										// 直接使用样式设置，因为FontName命令可能不稳定
										const selectedNodes = selection.getSelectedBlocks()
										if (selectedNodes.length > 0) {
											selectedNodes.forEach(node => {
												editor.dom.setStyle(node, 'font-family', copiedFormat.fontFamily)
											})
										} else {
											// 如果没有选中块，应用到选中的内联内容
											editor.dom.setStyle(selection.getNode(), 'font-family', copiedFormat.fontFamily)
										}
									}
									if (copiedFormat.fontSize && copiedFormat.fontSize !== '' && copiedFormat.fontSize !== 'inherit') {
										console.log('手动应用字体大小:', copiedFormat.fontSize)
										// 直接使用样式设置
										const selectedNodes = selection.getSelectedBlocks()
										if (selectedNodes.length > 0) {
											selectedNodes.forEach(node => {
												editor.dom.setStyle(node, 'font-size', copiedFormat.fontSize)
											})
										} else {
											editor.dom.setStyle(selection.getNode(), 'font-size', copiedFormat.fontSize)
										}
									}

									// 应用段落样式属性 - 重新设计段落格式应用逻辑
									console.log('开始应用段落格式')

									// 获取所有选中的块级元素（段落）- 改进多行处理
									const selectedBlocks = selection.getSelectedBlocks()
									console.log('选中的块级元素:', selectedBlocks)
									console.log('选中的块级元素数量:', selectedBlocks.length)

									// 如果没有选中块级元素，尝试获取当前段落
									let targetBlocks = selectedBlocks.length > 0 ? selectedBlocks : []
									if (targetBlocks.length === 0 && targetElement) {
										targetBlocks = [targetElement]
									}

									// 特殊处理：如果选中了多行，确保获取所有相关的段落
									if (targetBlocks.length > 1) {
										console.log('检测到多行选择，特殊处理首行缩进')
										// 过滤出真正的段落元素
										targetBlocks = targetBlocks.filter(block => {
											const tagName = block.tagName.toLowerCase()
											return ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tagName)
										})
										console.log('过滤后的段落元素:', targetBlocks)
									}

									console.log('最终目标块级元素:', targetBlocks)

									// 对每个目标块级元素应用段落格式 - 手动应用强制模式，首行缩进特殊处理
									targetBlocks.forEach((block, index) => {
										console.log(`手动处理第${index + 1}个块级元素:`, block.tagName)
										console.log('手动应用前的元素样式:', block.getAttribute('style'))

										// 特别处理首行缩进 - 多行时只对第一个段落应用
										if (copiedFormat.textIndent && copiedFormat.textIndent !== '' && copiedFormat.textIndent !== '0px' && copiedFormat.textIndent !== 'none') {
											console.log(`手动对${block.tagName}应用首行缩进:`, copiedFormat.textIndent)
											console.log('多行选择状态:', targetBlocks.length > 1)
											console.log('当前是第几个段落:', index + 1)

											// 确保这是一个真正的段落元素
											const tagName = block.tagName.toLowerCase()
											if (['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tagName)) {
												// 多行时只对第一个段落应用首行缩进
												if (targetBlocks.length > 1) {
													if (index === 0) {
														console.log('多行模式：对第一个段落应用首行缩进')
														const result = applyTextIndent(block, copiedFormat.textIndent)
														console.log(`手动应用首行缩进到第一个${tagName}结果:`, result)
													} else {
														console.log(`多行模式：跳过第${index + 1}个段落的首行缩进`)
													}
												} else {
													// 单行时正常应用
													console.log('单行模式：正常应用首行缩进')
													const result = applyTextIndent(block, copiedFormat.textIndent)
													console.log(`手动应用首行缩进到${tagName}结果:`, result)
												}
											} else {
												console.log(`跳过非段落元素: ${tagName}`)
											}
										}

										// 特别处理文本对齐 - 强制应用
										if (copiedFormat.textAlign && copiedFormat.textAlign !== '' && copiedFormat.textAlign !== 'start' && copiedFormat.textAlign !== 'initial') {
											console.log(`手动对${block.tagName}应用文本对齐:`, copiedFormat.textAlign)

											// 使用多种方式确保应用成功
											editor.dom.setStyle(block, 'text-align', copiedFormat.textAlign)
											block.style.textAlign = copiedFormat.textAlign

											// 验证是否应用成功
											const appliedAlign = editor.dom.getStyle(block, 'text-align')
											console.log('手动应用后的对齐值:', appliedAlign)
											console.log('DOM直接读取的对齐值:', block.style.textAlign)
										}

										// 特别处理行高 - 强制应用
										if (copiedFormat.lineHeight && copiedFormat.lineHeight !== '' && copiedFormat.lineHeight !== 'normal' && copiedFormat.lineHeight !== '1') {
											console.log(`手动对${block.tagName}应用行高:`, copiedFormat.lineHeight)

											// 使用多种方式确保应用成功
											editor.dom.setStyle(block, 'line-height', copiedFormat.lineHeight)
											block.style.lineHeight = copiedFormat.lineHeight

											// 验证是否应用成功
											const appliedLineHeight = editor.dom.getStyle(block, 'line-height')
											console.log('手动应用后的行高值:', appliedLineHeight)
											console.log('DOM直接读取的行高值:', block.style.lineHeight)
										}

										// 处理其他段落样式
										Object.keys(copiedFormat).forEach(style => {
											if (copiedFormat[style] && !['isBold', 'isItalic', 'isUnderline', 'color', 'backgroundColor', 'fontFamily', 'fontSize', 'textIndent', 'textAlign', 'lineHeight'].includes(style)) {
												const cssStyle = style.replace(/([A-Z])/g, '-$1').toLowerCase()
												const value = copiedFormat[style]

												if (value && value !== '' && value !== 'none' && value !== 'normal' && value !== 'auto' && value !== 'inherit' && value !== '0px' && value !== 'start' && value !== 'initial') {
													console.log(`手动对${block.tagName}应用其他样式: ${cssStyle} = ${value}`)
													editor.dom.setStyle(block, cssStyle, value)
													block.style[style] = value
												}
											}
										})

										console.log('手动应用后的元素样式:', block.getAttribute('style'))
									})

									// 强制刷新编辑器显示
									editor.nodeChanged()
									editor.fire('change')

									// 显示成功提示
									editor.notificationManager.open({
										text: '格式已应用成功！',
										type: 'success',
										timeout: 2000
									})
								}

								// 重置格式刷状态 - 手动应用完成后重置
								console.log('手动应用完成，重置格式刷状态')
								formatPainterActive = false
								copiedFormat = null
								isApplyingFormat = false // 重置应用标志
								api.setActive(false)

								// 恢复按钮样式为普通状态
								setTimeout(() => {
									const button = document.querySelector('[aria-label*="格式刷"]')
									if (button) {
										button.style.backgroundColor = ''
										button.style.color = ''
										button.style.border = ''
										button.style.boxShadow = ''
										button.style.transform = ''
										// 恢复普通状态的图标
										const icon = button.querySelector('svg')
										if (icon) {
											icon.innerHTML = '<path d="M8 3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V4H17C17.5523 4 18 4.44772 18 5V7C18 7.55228 17.5523 8 17 8H16V9L12 13L8 9V8H7C6.44772 8 6 7.55228 6 7V5C6 4.44772 6.44772 4 7 4H8V3Z" fill="currentColor"/><path d="M10 14L12 16L14 14V20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20V14Z" fill="currentColor"/><circle cx="12" cy="5.5" r="0.5" fill="white"/>'
										}
									}
								}, 100)
							}
						}
					})

					// 添加选区变化监听，自动应用格式（更像Word的体验）
					let lastSelectionContent = ''
					let isApplyingFormat = false // 添加标志防止重复应用

					editor.on('selectionchange', function() {
						if (formatPainterActive && copiedFormat && !isApplyingFormat) {
							const currentSelection = editor.selection
							const currentContent = currentSelection.getContent()

							// 如果用户选中了新的内容（不同于上次选中的内容）
							if (currentContent && !currentSelection.isCollapsed() && currentContent !== lastSelectionContent) {
								lastSelectionContent = currentContent
								isApplyingFormat = true // 设置标志，防止重复应用

								// 延迟一点时间，确保选区稳定
								setTimeout(() => {
									// 双重检查，确保格式刷仍然激活且没有被重置
									if (formatPainterActive && copiedFormat && isApplyingFormat) {
										console.log('检测到新的选区，自动应用格式')

										// 立即设置为非激活状态，防止重复应用
										formatPainterActive = false

										// 自动应用格式 - 改进应用逻辑
										console.log('开始自动应用格式，复制的格式:', copiedFormat)

										// 保存当前选区
										const currentRange = currentSelection.getRng()
										const targetNode = currentSelection.getNode()
										const targetElement = editor.dom.getParent(targetNode, 'p,div,span,h1,h2,h3,h4,h5,h6')

										console.log('目标节点:', targetNode)
										console.log('目标元素:', targetElement)

										// 应用颜色格式（先应用颜色，因为这些命令需要选区）
										if (copiedFormat.color && copiedFormat.color !== '' && copiedFormat.color !== 'rgb(0, 0, 0)') {
											console.log('应用前景色:', copiedFormat.color)
											editor.execCommand('ForeColor', false, copiedFormat.color)
										}
										if (copiedFormat.backgroundColor && copiedFormat.backgroundColor !== '' && copiedFormat.backgroundColor !== 'rgba(0, 0, 0, 0)' && copiedFormat.backgroundColor !== 'transparent') {
											console.log('应用背景色:', copiedFormat.backgroundColor)
											editor.execCommand('HiliteColor', false, copiedFormat.backgroundColor)
										}

										// 应用文本格式（粗体、斜体、下划线）- 改进自动应用方式
										if (copiedFormat.isBold) {
											console.log('自动应用粗体格式，当前选区:', currentSelection.getContent())
											const currentNode = currentSelection.getNode()
											const currentWeight = window.getComputedStyle(currentNode).fontWeight
											console.log('当前字体粗细:', currentWeight)
											if (parseInt(currentWeight) < 700) {
												editor.execCommand('Bold')
											}
										}
										if (copiedFormat.isItalic) {
											console.log('自动应用斜体格式')
											const currentNode = currentSelection.getNode()
											const currentStyle = window.getComputedStyle(currentNode).fontStyle
											if (currentStyle !== 'italic') {
												editor.execCommand('Italic')
											}
										}
										if (copiedFormat.isUnderline) {
											console.log('自动应用下划线格式')
											const currentNode = currentSelection.getNode()
											const currentDecoration = window.getComputedStyle(currentNode).textDecoration
											if (!currentDecoration.includes('underline')) {
												editor.execCommand('Underline')
											}
										}

										// 应用字体相关样式 - 改进自动字体应用方式
										if (copiedFormat.fontFamily && copiedFormat.fontFamily !== '' && copiedFormat.fontFamily !== 'inherit') {
											console.log('自动应用字体:', copiedFormat.fontFamily)
											const selectedNodes = currentSelection.getSelectedBlocks()
											if (selectedNodes.length > 0) {
												selectedNodes.forEach(node => {
													editor.dom.setStyle(node, 'font-family', copiedFormat.fontFamily)
												})
											} else {
												editor.dom.setStyle(currentSelection.getNode(), 'font-family', copiedFormat.fontFamily)
											}
										}
										if (copiedFormat.fontSize && copiedFormat.fontSize !== '' && copiedFormat.fontSize !== 'inherit') {
											console.log('自动应用字体大小:', copiedFormat.fontSize)
											const selectedNodes = currentSelection.getSelectedBlocks()
											if (selectedNodes.length > 0) {
												selectedNodes.forEach(node => {
													editor.dom.setStyle(node, 'font-size', copiedFormat.fontSize)
												})
											} else {
												editor.dom.setStyle(currentSelection.getNode(), 'font-size', copiedFormat.fontSize)
											}
										}

										// 应用段落样式属性 - 重新设计自动段落格式应用逻辑
										console.log('开始自动应用段落格式')

										// 获取所有选中的块级元素（段落）- 改进多行处理
										const selectedBlocks = currentSelection.getSelectedBlocks()
										console.log('自动应用-选中的块级元素:', selectedBlocks)
										console.log('自动应用-选中的块级元素数量:', selectedBlocks.length)

										// 如果没有选中块级元素，尝试获取当前段落
										let targetBlocks = selectedBlocks.length > 0 ? selectedBlocks : []
										if (targetBlocks.length === 0 && targetElement) {
											targetBlocks = [targetElement]
										}

										// 特殊处理：如果选中了多行，确保获取所有相关的段落
										if (targetBlocks.length > 1) {
											console.log('自动应用-检测到多行选择，特殊处理首行缩进')
											// 过滤出真正的段落元素
											targetBlocks = targetBlocks.filter(block => {
												const tagName = block.tagName.toLowerCase()
												return ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tagName)
											})
											console.log('自动应用-过滤后的段落元素:', targetBlocks)
										}

										console.log('自动应用-最终目标块级元素:', targetBlocks)

										// 对每个目标块级元素应用段落格式 - 改进应用方式
										targetBlocks.forEach((block, index) => {
											console.log(`自动处理第${index + 1}个块级元素:`, block.tagName)
											console.log('应用前的元素样式:', block.getAttribute('style'))

											// 特别处理首行缩进 - 多行时只对第一个段落应用
											if (copiedFormat.textIndent && copiedFormat.textIndent !== '' && copiedFormat.textIndent !== '0px' && copiedFormat.textIndent !== 'none') {
												console.log(`自动对${block.tagName}应用首行缩进:`, copiedFormat.textIndent)
												console.log('自动应用-多行选择状态:', targetBlocks.length > 1)
												console.log('自动应用-当前是第几个段落:', index + 1)

												// 确保这是一个真正的段落元素
												const tagName = block.tagName.toLowerCase()
												if (['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tagName)) {
													// 多行时只对第一个段落应用首行缩进
													if (targetBlocks.length > 1) {
														if (index === 0) {
															console.log('自动多行模式：对第一个段落应用首行缩进')
															const result = applyTextIndent(block, copiedFormat.textIndent)
															console.log(`自动应用首行缩进到第一个${tagName}结果:`, result)
														} else {
															console.log(`自动多行模式：跳过第${index + 1}个段落的首行缩进`)
														}
													} else {
														// 单行时正常应用
														console.log('自动单行模式：正常应用首行缩进')
														const result = applyTextIndent(block, copiedFormat.textIndent)
														console.log(`自动应用首行缩进到${tagName}结果:`, result)
													}
												} else {
													console.log(`自动应用-跳过非段落元素: ${tagName}`)
												}
											}

											// 特别处理文本对齐 - 强制应用
											if (copiedFormat.textAlign && copiedFormat.textAlign !== '' && copiedFormat.textAlign !== 'start' && copiedFormat.textAlign !== 'initial') {
												console.log(`自动对${block.tagName}应用文本对齐:`, copiedFormat.textAlign)

												// 使用多种方式确保应用成功
												editor.dom.setStyle(block, 'text-align', copiedFormat.textAlign)
												block.style.textAlign = copiedFormat.textAlign

												// 验证是否应用成功
												const appliedAlign = editor.dom.getStyle(block, 'text-align')
												console.log('自动应用后的对齐值:', appliedAlign)
												console.log('DOM直接读取的对齐值:', block.style.textAlign)
											}

											// 特别处理行高 - 强制应用
											if (copiedFormat.lineHeight && copiedFormat.lineHeight !== '' && copiedFormat.lineHeight !== 'normal' && copiedFormat.lineHeight !== '1') {
												console.log(`自动对${block.tagName}应用行高:`, copiedFormat.lineHeight)

												// 使用多种方式确保应用成功
												editor.dom.setStyle(block, 'line-height', copiedFormat.lineHeight)
												block.style.lineHeight = copiedFormat.lineHeight

												// 验证是否应用成功
												const appliedLineHeight = editor.dom.getStyle(block, 'line-height')
												console.log('自动应用后的行高值:', appliedLineHeight)
												console.log('DOM直接读取的行高值:', block.style.lineHeight)
											}

											// 处理其他段落样式
											Object.keys(copiedFormat).forEach(style => {
												if (copiedFormat[style] && !['isBold', 'isItalic', 'isUnderline', 'color', 'backgroundColor', 'fontFamily', 'fontSize', 'textIndent', 'textAlign', 'lineHeight'].includes(style)) {
													const cssStyle = style.replace(/([A-Z])/g, '-$1').toLowerCase()
													const value = copiedFormat[style]

													if (value && value !== '' && value !== 'none' && value !== 'normal' && value !== 'auto' && value !== 'inherit' && value !== '0px' && value !== 'start' && value !== 'initial') {
														console.log(`自动对${block.tagName}应用其他样式: ${cssStyle} = ${value}`)
														editor.dom.setStyle(block, cssStyle, value)
														block.style[style] = value
													}
												}
											})

											console.log('应用后的元素样式:', block.getAttribute('style'))
										})

										// 强制刷新编辑器显示
										editor.nodeChanged()
										editor.fire('change')

										// 显示成功提示
										editor.notificationManager.open({
											text: '格式已自动应用！',
											type: 'success',
											timeout: 2000
										})

										// 重置格式刷状态 - 改进重置逻辑
										console.log('开始重置格式刷状态')
										formatPainterActive = false
										copiedFormat = null
										lastSelectionContent = ''
										isApplyingFormat = false // 重置应用标志

										// 更新按钮状态 - 确保按钮正确重置
										setTimeout(() => {
											const button = document.querySelector('[aria-label*="格式刷"]')
											if (button) {
												console.log('重置按钮样式')
												button.style.backgroundColor = ''
												button.style.color = ''
												button.style.border = ''
												button.style.boxShadow = ''
												button.style.transform = ''

												// 移除激活状态
												button.setAttribute('aria-pressed', 'false')

												const icon = button.querySelector('svg')
												if (icon) {
													icon.innerHTML = '<path d="M8 3C8 2.44772 8.44772 2 9 2H15C15.5523 2 16 2.44772 16 3V4H17C17.5523 4 18 4.44772 18 5V7C18 7.55228 17.5523 8 17 8H16V9L12 13L8 9V8H7C6.44772 8 6 7.55228 6 7V5C6 4.44772 6.44772 4 7 4H8V3Z" fill="currentColor"/><path d="M10 14L12 16L14 14V20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20V14Z" fill="currentColor"/><circle cx="12" cy="5.5" r="0.5" fill="white"/>'
												}
												console.log('格式刷按钮已重置')
											}
										}, 100)
									}
								}, 500) // 增加延迟时间，确保格式应用完成
							}
						}
					})

					// 键盘删除支持
					editor.on('keydown', (e) => {
						const selectedNode = editor.selection.getNode()
						if (selectedNode && selectedNode.getAttribute && selectedNode.getAttribute('data-wechat-placeholder')) {
							if (e.keyCode === 46 || e.keyCode === 8) { // Delete 或 Backspace
								e.preventDefault()
								const placeholderId = selectedNode.getAttribute('data-placeholder-id')
								console.log('键盘删除占位符:', placeholderId)
								editor.dom.remove(selectedNode)
								return false
							}
						}
					})

					// 添加点击事件监听器到编辑器
					editor.on('click', (e) => {
						const target = e.target
						// console.log('编辑器内点击事件:', target)
						// console.log('点击目标的类名:', target.className)
						// console.log('点击目标的data属性:', target.dataset)

						// 检查是否点击了上传按钮
						if (target.classList && target.classList.contains('wechat-upload-btn')) {
							e.preventDefault()
							e.stopPropagation()
							let placeholderId = target.getAttribute('data-placeholder-id')
							console.log('点击上传按钮，占位符ID:', placeholderId)

							// 尝试多种方式找到占位符
							let placeholderElement = document.getElementById(placeholderId)
							if (!placeholderElement) {
								// 通过按钮向上查找占位符容器
								placeholderElement = target.closest('[data-wechat-placeholder]')
								console.log('通过closest找到的占位符:', placeholderElement)
								if (placeholderElement) {
									placeholderId = placeholderElement.id || placeholderElement.getAttribute('data-placeholder-id')
								}
							}

							if (placeholderElement) {
								handleUploadImage(placeholderId, placeholderElement)
							} else {
								console.error('无法找到占位符元素')
							}
							return false
						}

						// 检查是否点击了删除按钮
						if (target.classList && target.classList.contains('wechat-delete-btn')) {
							e.preventDefault()
							e.stopPropagation()
							let placeholderId = target.getAttribute('data-placeholder-id')
							console.log('点击删除按钮，占位符ID:', placeholderId)

							// 尝试多种方式找到占位符
							let placeholderElement = document.getElementById(placeholderId)
							if (!placeholderElement) {
								// 通过按钮向上查找占位符容器
								placeholderElement = target.closest('[data-wechat-placeholder]')
								console.log('通过closest找到的占位符:', placeholderElement)
								if (placeholderElement) {
									placeholderId = placeholderElement.id || placeholderElement.getAttribute('data-placeholder-id')
								}
							}

							if (placeholderElement) {
								handleDeletePlaceholder(placeholderId, placeholderElement)
							} else {
								console.error('无法找到占位符元素')
							}
							return false
						}
					})

					// 添加工具栏按钮
					editor.ui.registry.addButton('wechatCleanup', {
						text: '清理微信图片',
						icon: 'remove',
						tooltip: '删除所有微信图片占位符',
						onAction: () => {
							const placeholders = editor.dom.select('[data-wechat-placeholder]')
							if (placeholders.length > 0) {
								if (confirm(`发现 ${placeholders.length} 个微信图片占位符，确定要全部删除吗？`)) {
									placeholders.forEach(placeholder => {
										editor.dom.remove(placeholder)
									})
									console.log('已清理所有微信图片占位符')
								}
							} else {
								alert('没有发现微信图片占位符')
							}
						}
					})
				}

				return init
			}

			//随机生成随机数
			function generateRandomString(length) {
				const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
				let result = ''
				const charactersLength = characters.length
				for (let i = 0; i < length; i++) {
					result += characters.charAt(Math.floor(Math.random() * charactersLength))
				}
				return result
			}

			// 处理微信图片
			function handleWechatImage(imgElement, originalSrc) {
				// 微信图片由于防盗链机制，无法直接使用
				// 创建一个简单的占位符，使用TinyMCE可以识别的结构

				// 生成唯一ID
				placeholderCounter++
				const uniqueId = 'wechat-placeholder-' + Date.now() + '-' + placeholderCounter

				// 创建一个简化的占位符HTML，使用TinyMCE友好的结构
				const placeholderHTML = `
					<p style="border: 2px dashed #ff6b6b; padding: 20px; text-align: center; background-color: #fff5f5; color: #666; margin: 10px 0; border-radius: 4px; display: block;"
					   id="${uniqueId}"
					   class="wechat-image-placeholder"
					   contenteditable="false"
					   data-wechat-placeholder="true"
					   data-placeholder-id="${uniqueId}">
						<strong style="color: #ff6b6b; font-size: 16px;">📷 微信图片无法直接粘贴</strong><br>
						<span style="font-size: 12px; color: #999;">由于微信防盗链机制，请手动上传图片</span><br><br>
						<button type="button"
								class="wechat-upload-btn"
								data-placeholder-id="${uniqueId}"
								style="background: #409eff; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-size: 12px; margin-right: 8px;">
							📤 上传图片
						</button>
						<button type="button"
								class="wechat-delete-btn"
								data-placeholder-id="${uniqueId}"
								style="background: #f56565; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-size: 12px;">
							🗑️ 删除
						</button><br>
						<small style="font-size: 10px; color: #999; margin-top: 8px; display: inline-block;">
							💡 也可以选中后按Delete键删除
						</small>
					</p>
				`

				console.log('准备插入占位符HTML，ID:', uniqueId)
				console.log('占位符HTML:', placeholderHTML)

				// 使用TinyMCE的API来插入内容，这样可以避免内容同步问题
				try {
					if (tinymce.activeEditor) {
						console.log('使用TinyMCE API插入占位符')

						// 选中要替换的图片
						tinymce.activeEditor.selection.select(imgElement)

						// 使用insertContent而不是setContent，这样更安全
						tinymce.activeEditor.insertContent(placeholderHTML)

						console.log('TinyMCE插入完成')

						// 验证插入是否成功
						setTimeout(() => {
							const insertedElement = document.getElementById(uniqueId)
							if (insertedElement) {
								console.log('TinyMCE插入成功，找到元素:', insertedElement)
							} else {
								console.error('TinyMCE插入失败，找不到元素:', uniqueId)
								// 尝试查找是否有相关元素
								const allPlaceholders = document.querySelectorAll('[data-wechat-placeholder]')
								console.log('当前所有占位符元素:', allPlaceholders)

								// 如果TinyMCE插入失败，尝试直接DOM操作
								tryDirectInsert()
							}
						}, 200)
					} else {
						console.log('没有活动编辑器，使用直接DOM插入')
						tryDirectInsert()
					}

					function tryDirectInsert() {
						try {
							console.log('尝试直接DOM插入占位符')

							// 创建占位符元素
							const tempDiv = document.createElement('div')
							tempDiv.innerHTML = placeholderHTML
							const placeholder = tempDiv.firstElementChild

							console.log('创建的占位符元素:', placeholder)

							// 直接替换原图片
							if (imgElement.parentNode) {
								imgElement.parentNode.replaceChild(placeholder, imgElement)
								console.log('直接DOM替换完成')

								// 通知TinyMCE内容已改变
								if (tinymce.activeEditor) {
									tinymce.activeEditor.fire('change')
									tinymce.activeEditor.fire('input')
								}
							} else {
								console.error('无法找到图片的父元素')
							}
						} catch (error) {
							console.error('直接DOM插入失败:', error)
						}
					}
				} catch (error) {
					console.error('插入占位符失败:', error)
				}
			}

			// 处理上传图片
			function handleUploadImage(placeholderId, placeholderElement = null) {
				console.log('处理上传图片:', placeholderId)

				try {
					const input = document.createElement('input')
					input.type = 'file'
					input.accept = 'image/*'
					input.style.display = 'none'
					input.style.position = 'absolute'
					input.style.left = '-9999px'

					console.log('创建文件输入框:', input)
					document.body.appendChild(input)

					input.addEventListener('change', (e) => {
						console.log('文件选择事件触发:', e)
						const file = e.target.files[0]
						if (file) {
							console.log('选择了文件:', file.name)

							// 找到占位符元素
							if (!placeholderElement) {
								placeholderElement = document.getElementById(placeholderId)
							}
							if (!placeholderElement) {
								// 尝试通过data属性查找
								placeholderElement = document.querySelector(`[data-placeholder-id="${placeholderId}"]`)
							}
							if (!placeholderElement) {
								console.error('找不到占位符元素:', placeholderId)
								document.body.removeChild(input)
								return
							}

							console.log('找到占位符元素:', placeholderElement)

							// 显示上传中状态
							const originalContent = placeholderElement.innerHTML
							placeholderElement.innerHTML = `
								<div style="margin-bottom: 10px;">
									<svg width="48" height="48" viewBox="0 0 24 24" fill="#409eff">
										<path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z">
											<animateTransform attributeName="transform" attributeType="XML" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
										</path>
									</svg>
								</div>
								<div style="font-size: 14px; color: #409eff;">正在上传图片...</div>
							`

							uploadImageFile(file, (uploadedUrl) => {
								console.log('上传成功:', uploadedUrl)

								// 使用TinyMCE替换内容
								if (tinymce.activeEditor) {
									const imgHTML = `<img src="${uploadedUrl}" style="max-width: 100%; height: auto;" />`
									tinymce.activeEditor.selection.select(placeholderElement)
									tinymce.activeEditor.selection.setContent(imgHTML)
								} else {
									// 备用方法：直接替换DOM
									const newImg = document.createElement('img')
									newImg.src = uploadedUrl
									newImg.style.maxWidth = '100%'
									newImg.style.height = 'auto'

									if (placeholderElement.parentNode) {
										placeholderElement.parentNode.replaceChild(newImg, placeholderElement)
									}
								}
							}, (error) => {
								console.error('上传失败:', error)
								alert('图片上传失败: ' + error)
								// 恢复原始内容
								placeholderElement.innerHTML = originalContent
							})
						} else {
							console.log('没有选择文件')
						}

						// 清理input元素
						try {
							document.body.removeChild(input)
						} catch (e) {
							console.warn('清理input元素失败:', e)
						}
					})

					// 添加错误处理
					input.addEventListener('error', (e) => {
						console.error('文件输入框错误:', e)
					})

					// 触发文件选择
					console.log('触发文件选择对话框')
					setTimeout(() => {
						input.click()
					}, 100)

				} catch (error) {
					console.error('创建文件选择器失败:', error)
					alert('无法打开文件选择器: ' + error.message)
				}
			}

			// 处理删除占位符
			function handleDeletePlaceholder(placeholderId, placeholderElement = null) {
				console.log('处理删除占位符:', placeholderId)

				try {
					// 找到占位符元素
					if (!placeholderElement) {
						placeholderElement = document.getElementById(placeholderId)
					}
					if (!placeholderElement) {
						// 尝试通过data属性查找
						placeholderElement = document.querySelector(`[data-placeholder-id="${placeholderId}"]`)
					}
					if (!placeholderElement) {
						console.error('找不到占位符元素:', placeholderId)
						// 列出所有占位符元素进行调试
						const allPlaceholders = document.querySelectorAll('[data-wechat-placeholder]')
						console.log('当前所有占位符元素:', allPlaceholders)
						return
					}

					console.log('找到占位符元素:', placeholderElement)

					// 多种删除方法
					let deleted = false

					// 方法1: 使用TinyMCE删除
					if (tinymce.activeEditor && !deleted) {
						try {
							console.log('尝试使用TinyMCE删除')
							tinymce.activeEditor.selection.select(placeholderElement)
							tinymce.activeEditor.execCommand('Delete')

							// 检查是否删除成功
							setTimeout(() => {
								if (!document.getElementById(placeholderId)) {
									console.log('TinyMCE删除成功')
									deleted = true
								} else {
									console.log('TinyMCE删除失败，尝试其他方法')
									// 如果TinyMCE删除失败，尝试直接删除
									tryDirectDelete()
								}
							}, 100)
						} catch (error) {
							console.error('TinyMCE删除失败:', error)
							tryDirectDelete()
						}
					} else {
						tryDirectDelete()
					}

					function tryDirectDelete() {
						try {
							console.log('尝试直接从DOM删除')
							if (placeholderElement.parentNode) {
								placeholderElement.parentNode.removeChild(placeholderElement)
								console.log('直接删除成功')
								deleted = true
							}
						} catch (error) {
							console.error('直接删除失败:', error)
							// 最后尝试隐藏
							try {
								placeholderElement.style.display = 'none'
								placeholderElement.style.visibility = 'hidden'
								placeholderElement.style.height = '0'
								placeholderElement.style.margin = '0'
								placeholderElement.style.padding = '0'
								console.log('隐藏占位符成功')
							} catch (hideError) {
								console.error('隐藏占位符也失败了:', hideError)
							}
						}
					}

				} catch (error) {
					console.error('删除占位符过程中出错:', error)
				}
			}

			// 将外部图片转换为本地图片
			function convertExternalImageToLocal(imgElement, originalSrc) {
				// 显示加载状态
				imgElement.style.opacity = '0.5'
				imgElement.setAttribute('title', '图片上传中...')

				// 创建一个canvas来处理图片
				const canvas = document.createElement('canvas')
				const ctx = canvas.getContext('2d')
				const img = new Image()

				// 设置跨域属性
				img.crossOrigin = 'anonymous'

				img.onload = function() {
					try {
						canvas.width = img.width
						canvas.height = img.height
						ctx.drawImage(img, 0, 0)

						// 将canvas转换为blob
						canvas.toBlob(function(blob) {
							if (blob) {
								// 创建一个文件名
								const fileName = generateRandomString(10) + '.png'
								const file = new File([blob], fileName, { type: 'image/png' })

								// 上传图片
								uploadImageFile(file, (uploadedUrl) => {
									// 替换图片src
									imgElement.src = uploadedUrl
									imgElement.style.opacity = '1'
									imgElement.removeAttribute('title')
								}, (error) => {
									// 上传失败，显示错误信息
									imgElement.style.opacity = '1'
									imgElement.setAttribute('title', '图片上传失败: ' + error)
									imgElement.setAttribute('alt', '图片上传失败')
								})
							} else {
								imgElement.style.opacity = '1'
								imgElement.setAttribute('title', '图片处理失败')
							}
						}, 'image/png', 0.8)
					} catch (error) {
						console.error('图片处理失败:', error)
						imgElement.style.opacity = '1'
						imgElement.setAttribute('title', '图片处理失败: ' + error.message)
					}
				}

				img.onerror = function() {
					// 如果直接加载失败，尝试通过代理加载
					console.warn('直接加载图片失败，尝试其他方式:', originalSrc)
					imgElement.style.opacity = '1'
					imgElement.setAttribute('title', '外部图片无法访问，请手动上传图片')
					imgElement.setAttribute('alt', '图片加载失败')
				}

				// 尝试加载图片
				img.src = originalSrc
			}

			// 上传图片文件的辅助函数
			function uploadImageFile(file, success, failure) {
				const params = new FormData()
				params.append('file', file)
				params.append('dirs', 'article')

				const config = {
					headers: {
						'Content-Type': 'multipart/form-data',
						'Authorization': 'JWT ' + token,
					}
				}

				const uploadurl = url + 'article/upload/'

				axios.post(uploadurl, params, config).then(res => {
					if (res.data.code == 2000) {
						let imgpath = ''
						if (res.data.data.data[0].indexOf("://") >= 0) {
							imgpath = res.data.data.data[0]
						} else {
							imgpath = "http://" + mediaUrl + '/media' + res.data.data.data[0]
						}
						success(imgpath)
					} else {
						failure(res.data.msg || '上传失败')
					}
				}).catch(err => {
					console.error('图片上传错误:', err)
					failure('上传出错，服务器开小差了呢')
				})
			}

			function viedoUploadFn(callback, valute, meta) {
				if (meta.filetype == 'media') {
					
					const input = document.createElement('input')
					input.setAttribute('type', 'file')
					input.addEventListener("change",e=> {
						const loading = ElLoading.service({
							lock: true,
							text: '文件上传中...',
							background: 'rgba(0, 0, 0, 0.7)',
						})
						let box = document.querySelector(".el-loading-mask");
						box.style.zIndex = "999999999"
						
						console.log(ElLoading,loading)
						const params = new FormData()
						const blob = e.target.files[0]
						params.append('file', blob)
						params.append('dirs', 'media')

						const config = {
							headers: {
								'Content-Type': 'multipart/form-data',
								'Authorization': 'JWT ' + token
							}
						}
						const uploadurl = url + 'article/upload/'
						axios.post(uploadurl, params, config).then(res => {
							if (res.data.code == 2000) {
								let imgpath = ''
								if (res.data.data.data[0].indexOf("://") >= 0) imgpath = res.data.data.data[0]
								else imgpath = "http://" + mediaUrl + '/media' + res.data.data.data[0]
								callback(imgpath, {
									title: blob.name
								})
							} else callback(res.data.msg, {
								title: blob.name
							})
							loading.close()
						}).catch(err => {
							callback("视频由于不可抗力因素导致上传失败，请联系管理员后上传", {
								title: blob.name
							})
							loading.close()
						})
					})
					input.click()
				}
			}

			function imgUploadFn(blobInfo, success, failure) {
				// 可以限制图片大小
				// if (blobInfo.blob().size / 1024 / 1024 > 2) {
				//   failure('上传失败，图片大小请控制在 2M 以内')
				// } else {}
				const params = new FormData()
				const blob = blobInfo.blob()
				const formater = blob.type.substr(blob.type.lastIndexOf("/") + 1)

				params.append('file', blob, generateRandomString(10) + "." + formater)
				params.append('dirs', 'article')

				const config = {
					headers: {
						'Content-Type': 'multipart/form-data',
						'Authorization': 'JWT ' + token, // 可选参数(服务器上传验证需要) 如果需要token验证，假设你的token有存放在sessionStorage
					}
				}
				// const uploadurl = url + 'platformsettings/uploadplatformimg/'
				const uploadurl = url + 'article/upload/'
				// 图片上传
				axios.post(uploadurl, params, config).then(res => {

					if (res.data.code == 2000) {
						//这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
						let imgpath = ''
						if (res.data.data.data[0].indexOf("://") >= 0) {
							imgpath = res.data.data.data[0]

						} else {
							imgpath = "http://" + mediaUrl + '/media' + res.data.data.data[0]
						}
						success(imgpath) // 上传成功，在成功函数里填入图片路径
						// console.log('[文件上传]', res.data)
					} else {
						failure('上传失败')
					}
				}).catch(() => {
					failure('上传出错，服务器开小差了呢')
				})
			}

			return ({
				...toRefs(state),
				customer,
				debounce
			})
		}
	}
</script>

<style lang="css">
	.my-tinymce {
		width: 100%;
	}

	.editor-tips {
		margin-bottom: 10px;
		padding: 8px 12px;
		background-color: #f0f9ff;
		border: 1px solid #b3d8ff;
		border-radius: 4px;
		font-size: 13px;
	}

	.tip-item {
		display: flex;
		align-items: center;
		color: #1f2937;
	}

	.tip-icon {
		margin-right: 6px;
		font-size: 14px;
	}

	.tip-text {
		line-height: 1.4;
	}

	.tox-notifications-container {
		display: none;
	}

	/* 改善编辑器整体样式 */
	.tox-tinymce {
		border-radius: 6px !important;
		border: 1px solid #dcdfe6 !important;
	}

	.tox-toolbar-overlord {
		background: #f8f9fa !important;
	}

	.tox-edit-area {
		border-top: 1px solid #e4e7ed !important;
	}

	/* 改善编辑区域的字体显示 */
	.tox-edit-area iframe {
		font-size: 16px !important;
	}

	/* 状态栏样式 */
	.tox-statusbar {
		background: #f8f9fa !important;
		border-top: 1px solid #e4e7ed !important;
	}

	/*.tox-tinymce-aux {*/
	/*  z-index: 5000 !important;*/
	/*}*/
</style>

<style lang="scss">
	// 全局样式，用于微信图片占位符
	.wechat-image-placeholder {
		&:hover {
			border-color: #409eff !important;
			background-color: #ecf5ff !important;
		}

		&:focus,
		&[data-mce-selected="1"] {
			border-color: #409eff !important;
			background-color: #ecf5ff !important;
			box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2) !important;
		}

		.placeholder-close {
			opacity: 0.9;
			transition: all 0.2s ease;
			pointer-events: auto !important;

			&:hover {
				opacity: 1 !important;
				background: #e74c3c !important;
				transform: scale(1.1) !important;
				box-shadow: 0 4px 8px rgba(0,0,0,0.3) !important;
			}

			&:active {
				transform: scale(0.95) !important;
				background: #c0392b !important;
			}
		}

		.upload-btn {
			transition: background-color 0.2s;

			&:hover {
				background: #337ab7 !important;
			}

			&:disabled {
				background: #ccc !important;
				cursor: not-allowed !important;
			}
		}

		.delete-btn {
			transition: background-color 0.2s;

			&:hover {
				background: #e53e3e !important;
			}
		}
	}

	// TinyMCE编辑器内的占位符样式
	.tox-edit-area {
		.wechat-image-placeholder {
			outline: none !important;
			transition: all 0.2s ease !important;

			&:hover {
				border-color: #409eff !important;
				background-color: #ecf5ff !important;
				transform: scale(1.02) !important;
				box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2) !important;
			}

			&:focus,
			&[data-mce-selected="1"] {
				border-color: #409eff !important;
				background-color: #ecf5ff !important;
				box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2) !important;
			}
		}
	}

	/* Word风格的格式刷按钮样式 */
	:deep(.tox-toolbar) {
		/* 格式刷按钮的基础样式 */
		.tox-tbtn[aria-label*="格式刷"] {
			position: relative;
			transition: all 0.2s ease-in-out;
			border-radius: 3px;

			&:hover {
				background-color: #f3f2f1 !important;
				border: 1px solid #c7c7c7 !important;
			}

			/* 激活状态的样式 */
			&[aria-pressed="true"] {
				background-color: #0078d4 !important;
				color: white !important;
				border: 2px solid #106ebe !important;
				box-shadow: 0 0 0 1px #106ebe !important;
				transform: scale(1.05) !important;

				&:hover {
					background-color: #106ebe !important;
					border: 2px solid #005a9e !important;
				}

				/* 添加一个小的闪烁效果表示激活 */
				&::after {
					content: '';
					position: absolute;
					top: -2px;
					right: -2px;
					width: 6px;
					height: 6px;
					background-color: #ffd700;
					border-radius: 50%;
					animation: formatPainterBlink 1.5s infinite;
				}
			}
		}
	}

	/* 格式刷激活状态的闪烁动画 */
	@keyframes formatPainterBlink {
		0%, 50% { opacity: 1; }
		25%, 75% { opacity: 0.3; }
	}

	/* 格式刷工具提示增强 */
	:deep(.tox-tooltip) {
		&[data-mce-tooltip*="格式刷"] {
			background-color: #323130;
			color: white;
			border: 1px solid #605e5c;
			border-radius: 2px;
			font-size: 12px;
			max-width: 300px;

			&::before {
				border-top-color: #323130;
			}
		}
	}
</style>